import { AgdActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const AgdReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case AgdActionType.Agd_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default AgdReducer
